import React, {Component} from 'react'
import './styles.scss';

class Panel extends Component {
    render() {
        return <div className="Panel">{this.props.children}</div>;
    }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Panel/index.js